import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PrimerCardNetworksMetadataAndroid from './primerCardNetworksMetadata.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='cardNumberEntryMetadata' subtitle='PrimerCardNumberEntryMetadata' label='Required' mdxType="Item">
 Represents metadata for PrimerCardNumberEntry, including selectable (co-badged) and detected card networks.
      <Group open summary='Properties' mdxType="Group">
  <Item title='selectableCardNetworks' subtitle='PrimerCardNetworksMetadata?' mdxType="Item">
    Selectable card networks for a given card number, will be null in case card network is not co-badged.
      <PrimerCardNetworksMetadataAndroid mdxType="PrimerCardNetworksMetadataAndroid" />
  </Item>
  <Item title='detectedCardNetworks' subtitle='PrimerCardNetworksMetadata' label='Required' mdxType="Item">
    All detected card networks for a given card number.
      <PrimerCardNetworksMetadataAndroid mdxType="PrimerCardNetworksMetadataAndroid" />
  </Item>
  <Item title='source' subtitle='enum ValidationSource' label='Required' mdxType="Item">
    Enum class representing the source of validation for card metadata.
    <Group open summary='cases' mdxType="Group">
      <Item title='ValidationSource.REMOTE' mdxType="Item">
       The data comes from Primer API.
      </Item>
      <Item title='ValidationSource.LOCAL_FALLBACK' mdxType="Item">
        The data comes from the SDK if Primer's server fails to be reached. This works similarly to LOCAL.
      </Item>
      <Item title='ValidationSource.LOCAL' mdxType="Item">
       The data comes from the SDK, usually by levering the first few digits.
      </Item>
    </Group>
  </Item>
  </Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      